import { render, staticRenderFns } from "./NewTextAreaWidget.vue?vue&type=template&id=68bf6c06&"
import script from "./NewTextAreaWidget.vue?vue&type=script&lang=ts&"
export * from "./NewTextAreaWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports